import React, { FunctionComponent, useEffect } from "react";
import "./VideoLessonsDashboard.scss";
import VideoCard from "../../../Components/VideoCard/VideoCard";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../Redux/Store/Hooks";
import { listVideoSubject } from "../../../Redux/Slices/UserVideoLessons/ListVideosubjectSlice";
import { VideoLessonsDashboardProps } from "./IVideoLessonDashboard";
import {
  clearListuser,
  listUser,
} from "../../../Redux/Slices/User/ListUserSlice";
import Menus from "../../../Components/Menu/Menu";
import IconButtonField from "../../../Components/Button/IconButtonField";
import Avatars from "../../../Components/Avatar/Avatars";
import { clearLoginStatus } from "../../../Redux/Slices/LoginSlicer/LoginSlicer";
import { clearDashboardChart } from "../../../Redux/Slices/DashboardChart/DashboardChart";
import { useMediaQuery, useTheme } from "@mui/material";
import UserProfileSection from "../../../Components/UserProfileSection/UserProfileSection";

const VideoLessonsDashboard: FunctionComponent = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isUCAT =
    window.location.hostname.split(".")[0]?.includes("ucat") ||
    window.location.hostname.split(".")[0] === "192";

  useEffect(() => {
    dispatch(listVideoSubject());
  }, [dispatch]);

  const { data: subjectFromAPI } = useAppSelector(
    (state) => state.ListVideoSubjectSliceReducer
  );

  const handleCardClick = (
    link: string,
    subject: VideoLessonsDashboardProps
  ) => {
    navigate(link, {
      state: {
        subjectId: subject.id,
        Subject_name: subject.name,
      },
    });
  };

  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );
  const ListUser = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];
  useEffect(() => {
    dispatch(listUser());
  }, [dispatch]);

  return (
    <>
      {isMobile === false && (
        <div className="support_navbar_main">
          <UserProfileSection />
        </div>
      )}
      <div className="video-lessons-dashboard">
        <div className="dashboard-header">
          <h1>Video Lessons</h1>
          <p>Comprehensive video tutorials for each section of the {isUCAT ? "UCAT" : "GATE"} exam</p>
        </div>
        <div className="video-cards-grid">
          {subjectFromAPI?.data?.map((subject: VideoLessonsDashboardProps) => (
            <VideoCard
              key={subject.id}
              imageSrc={subject.image}
              title={subject.name}
              description={subject.description}
              // duration=""
              topic_count={subject?.topic_count}
              videoCount={Number(subject?.topic_count)}
              completion={0}
              buttonText="View Topics"
              onCardClick={() => handleCardClick(`/videolessonstopic`, subject)}
            >
              <p>{isUCAT ? "UCAT" : "GATE"} Exam Preparation</p>
            </VideoCard>
          ))}
        </div>
      </div>
    </>
  );
};

export default VideoLessonsDashboard;
